import { useAppSelector } from "@/store/hooks";

function useCheckoutSelector() {
    return useAppSelector(state => state.checkout);
}

export default useCheckoutSelector;
